(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Fondo Sun para fotos con fondo blanco.
     1) Se toma el color del fondo de los bordes de la foto. Si ya es de color (por ejemplo un estudio
        amarillo) o es transparente, no se hace nada: esas fotos ya cambian solas.
     2) Desde los bordes se avanza por los píxeles claros y neutros mientras la luminosidad cambie de forma
        suave (fondo y sombra del piso). El contorno de la prenda frena el avance. Después se buscan las
        islas de fondo que quedaron encerradas (entre un brazo y el torso, el cuello, un colgador) y se
        suman si las rodea algo claramente más oscuro.
     3) Todo ese fondo queda en Sun liso, sin degradado ni sombra; el contorno de la prenda se mezcla con
        Sun para que no quede un halo blanco. La prenda y sus colores no se tocan. */
  (function () {
    if (window.__kbSunPhoto) return;
    window.__kbSunPhoto = true;
    var queue = [], busy = false;
    var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 40); };

    function sunRGB(el) {
      var v = (window.getComputedStyle(el).getPropertyValue('--k-sun') || '').trim();
      var m = /^#?([0-9a-f]{6})$/i.exec(v);
      if (!m) return [219, 185, 15];
      var n = parseInt(m[1], 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }

    function median(a) { a.sort(function (x, y) { return x - y; }); return a[a.length >> 1]; }

    function recolor(img, sun) {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return null;
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var id;
      try { id = ctx.getImageData(0, 0, w, h); } catch (e) { return null; }
      var d = id.data, n = w * h, i, p, q;

      var rs = [], gs = [], bs = [], as = [], step = Math.max(1, Math.floor(Math.max(w, h) / 160));
      function take(x, y) { p = (y * w + x) * 4; rs.push(d[p]); gs.push(d[p + 1]); bs.push(d[p + 2]); as.push(d[p + 3]); }
      for (i = 0; i < w; i += step) { take(i, 0); take(i, h - 1); }
      for (i = 0; i < h; i += step) { take(0, i); take(w - 1, i); }
      if (median(as.slice()) < 250) return null;
      var B = [median(rs), median(gs), median(bs)];
      var bmin = Math.min(B[0], B[1], B[2]), bmax = Math.max(B[0], B[1], B[2]);
      if (bmin < 200 || bmax - bmin > 28) return null;

      var F = new Uint8Array(n), stack = new Int32Array(n), sp = 0, x, y;
      function nearBg(q) { return Math.abs(d[q] - B[0]) <= 18 && Math.abs(d[q + 1] - B[1]) <= 18 && Math.abs(d[q + 2] - B[2]) <= 18; }
      function seed(idx) { if (!F[idx] && nearBg(idx * 4)) { F[idx] = 1; stack[sp++] = idx; } }
      for (x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
      for (y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
      var lo = bmin * 0.6;
      /* Luminosidad mínima por píxel, suavizada en 3x3: el avance mira esta versión para no tropezar con el
         ruido del jpg, y el cambio entre vecinos que lo frena es pequeño (un borde de prenda blanca
         sobre fondo blanco cambia más rápido que una viñeta o la sombra del piso). */
      var bl = new Uint8Array(n), tmp = new Uint16Array(n), j;
      for (i = 0; i < n; i++) { p = i * 4; tmp[i] = Math.min(d[p], d[p + 1], d[p + 2]); }
      var tmp2 = new Uint16Array(n);
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        j = y * w + x;
        tmp2[j] = tmp[j] + tmp[x > 0 ? j - 1 : j] + tmp[x < w - 1 ? j + 1 : j];
      }
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        j = y * w + x;
        bl[j] = (tmp2[j] + tmp2[y > 0 ? j - w : j] + tmp2[y < h - 1 ? j + w : j]) / 9;
      }
      function grow(nb, cur) {
        if (F[nb]) return;
        var q = nb * 4, r = d[q], g = d[q + 1], b = d[q + 2];
        var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
        if (mx - mn <= 20 && mn >= lo && Math.abs(bl[nb] - bl[cur]) <= 3) { F[nb] = 1; stack[sp++] = nb; }
      }
      while (sp) {
        var cur = stack[--sp];
        x = cur % w; y = (cur - x) / w;
        if (x > 0) grow(cur - 1, cur);
        if (x < w - 1) grow(cur + 1, cur);
        if (y > 0) grow(cur - w, cur);
        if (y < h - 1) grow(cur + w, cur);
      }

      /* Islas de fondo: huecos entre un brazo y el torso, el cuello, un colgador. No tocan el borde de la
         foto, así que el avance de arriba no llega. Se buscan zonas claras y neutras que el avance no
         tomó y se pintan solo si están rodeadas por algo claramente más oscuro (la prenda). Una prenda
         blanca sobre fondo blanco forma una zona que toca el fondo o su propio color, y no se pinta. */
      var lab = new Uint8Array(n), comp = new Int32Array(n), minA = Math.max(120, Math.round(n * 0.0003)), sx, k, c, nb;
      function light(q) {
        var mn = Math.min(d[q], d[q + 1], d[q + 2]);
        return mn >= bmin - 30 && Math.max(d[q], d[q + 1], d[q + 2]) - mn <= 22;
      }
      for (i = 0; i < n; i++) {
        if (F[i] || lab[i] || !light(i * 4)) continue;
        sp = 0; k = 0; stack[sp++] = i; lab[i] = 1;
        var hard = 0, tot = 0, edge = false;
        while (sp) {
          c = stack[--sp]; comp[k++] = c;
          x = c % w; y = (c - x) / w;
          for (sx = 0; sx < 4; sx++) {
            if (sx === 0) { if (x === 0) { edge = true; continue; } nb = c - 1; }
            else if (sx === 1) { if (x === w - 1) { edge = true; continue; } nb = c + 1; }
            else if (sx === 2) { if (y === 0) { edge = true; continue; } nb = c - w; }
            else { if (y === h - 1) { edge = true; continue; } nb = c + w; }
            if (lab[nb]) continue;
            if (F[nb]) continue;
            if (light(nb * 4)) { lab[nb] = 1; stack[sp++] = nb; continue; }
            tot++; hard++;
          }
        }
        if (!edge && k >= minA && tot > 0 && hard >= tot * 0.7) { for (sx = 0; sx < k; sx++) F[comp[sx]] = 1; }
      }

      /* Si el fondo se comió casi toda la foto (prenda blanca sobre fondo blanco), no se recolorea: se avisa
         para que la ficha use el modo de mezcla que tiñe el blanco de Sun sin dejar espacios blancos. */
      var fill = 0;
      for (i = 0; i < n; i++) fill += F[i];
      if (fill > n * 0.92) return false;

      /* Borde de la prenda: el contorno antialias y el halo claro se mezclan con Sun en vez de quedar blancos. */
      var dr = B[0] - sun[0], dg = B[1] - sun[1], db = B[2] - sun[2];
      function soften(q) {
        var wgt = Math.min(1, Math.min(d[q], d[q + 1], d[q + 2]) / bmin);
        if (wgt > 0.985) { d[q] = sun[0]; d[q + 1] = sun[1]; d[q + 2] = sun[2]; return; }
        d[q] = Math.max(0, d[q] - wgt * dr);
        d[q + 1] = Math.max(0, d[q + 1] - wgt * dg);
        d[q + 2] = Math.max(0, d[q + 2] - wgt * db);
      }
      var R = new Uint8Array(n), pass;
      for (pass = 0; pass < 4; pass++) {
        var ring = [];
        for (i = 0; i < n; i++) {
          if (!F[i] && !R[i]) {
            x = i % w; y = (i - x) / w;
            if ((x > 0 && (F[i - 1] || R[i - 1] === 2)) || (x < w - 1 && (F[i + 1] || R[i + 1] === 2)) ||
                (y > 0 && (F[i - w] || R[i - w] === 2)) || (y < h - 1 && (F[i + w] || R[i + w] === 2))) {
              if (pass < 2 || (Math.min(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]) >= bmin * 0.9 && Math.max(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]) - Math.min(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]) <= 22)) ring.push(i);
            }
          }
        }
        for (i = 0; i < ring.length; i++) R[ring[i]] = 1;
        for (i = 0; i < ring.length; i++) R[ring[i]] = 2;
      }
      /* Fondo plano: todo lo que es fondo (incluida la sombra del piso) queda en Sun liso, sin degradado. */
      for (i = 0; i < n; i++) {
        q = i * 4;
        if (F[i]) { d[q] = sun[0]; d[q + 1] = sun[1]; d[q + 2] = sun[2]; d[q + 3] = 255; }
        else if (R[i]) { soften(q); d[q + 3] = 255; }
      }
      ctx.putImageData(id, 0, 0);
      return cv;
    }

    function prepare(card) {
      if (card.__kbSun) return;
      card.__kbSun = true;
      var img = card.querySelector(card.classList.contains('has-alt') ? '.kb-card__img--alt' : '.kb-card__img--main');
      if (!img || !img.src) return;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        queue.push(function () {
          var cv = recolor(im, sunRGB(card));
          if (cv === false) { card.classList.add('kb-card--tint'); return; }
          if (!cv) return;
          cv.className = 'kb-card__sun';
          cv.setAttribute('aria-hidden', 'true');
          img.parentNode.appendChild(cv);
          card.classList.add('has-sun-photo');
        });
        drain();
      };
      im.src = img.src;
    }

    function drain() {
      if (busy || !queue.length) return;
      busy = true;
      idle(function () {
        try { queue.shift()(); } catch (e) {}
        busy = false;
        drain();
      });
    }

    var io = 'IntersectionObserver' in window ? new window.IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); prepare(en.target); } });
    }, { rootMargin: '300px' }) : null;

    function scan(scope) {
      var cards = (scope || document).querySelectorAll('.kb-card--sun');
      Array.prototype.forEach.call(cards, function (c) { if (io) io.observe(c); });
    }

    document.addEventListener('mouseover', function (e) {
      var c = e.target.closest && e.target.closest('.kb-card--sun');
      if (c) prepare(c);
    });
    /* Botón "Agregar al carrito": despliega las tallas; al elegir una, kb-shop.js la agrega y abre la bolsa. */
    function closeSizes(except) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-kb-cta-sizes]:not([hidden])'), function (box) {
        if (box === except) return;
        box.hidden = true;
        var btn = box.parentNode.querySelector('[data-kb-cta-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var tg = t.closest('[data-kb-cta-toggle]');
      if (tg) {
        var box = tg.parentNode.querySelector('[data-kb-cta-sizes]');
        if (!box) return;
        var show = box.hidden;
        closeSizes(show ? box : null);
        box.hidden = !show;
        tg.setAttribute('aria-expanded', show ? 'true' : 'false');
        return;
      }
      if (t.closest('[data-kb-cta-sizes] [data-kb-quick-add]') || !t.closest('[data-kb-cta]')) closeSizes(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizes(null); });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
